import * as R from 'ramda';
import valueTreeParser from './valueTreeParser';
import { sortByOrderAndLabel } from '../../utils/sort';
import { search, getFacetDimensionId } from '../settings';

const fillTree = (valueParser) => (values) => {
  const missingKeys = R.converge(R.pipe(R.difference, R.reject(R.isNil)), [
    R.pluck('parentId'),
    R.pluck('id'),
  ])(values);
  if (R.isEmpty(missingKeys)) return values;
  const missingValues = R.map((val) => valueParser({ val }), missingKeys);
  return fillTree(valueParser)(R.concat(values, missingValues));
};

const rejectExcludedValuesFromDimensionFacet =
  ({ excludedFacetIds = [] }) =>
  (values) => {
    return R.reject((v) => R.includes(v.label, excludedFacetIds), values);
  };

export const prepareValues =
  ({ id, search, facetDimensionId }) =>
  (values) => {
    if (id === facetDimensionId)
      return rejectExcludedValuesFromDimensionFacet(search)(values);
    return values;
  };

export default (options) =>
  ([id, { buckets = [] }]) => {
    const localeId = options?.config?.localeId;
    const valueParser = valueTreeParser({ facetId: id, ...options });
    const rawValues = fillTree(valueParser)(R.map(valueParser, buckets));
    const values = prepareValues({
      id,
      search,
      facetDimensionId: getFacetDimensionId(localeId),
    })(rawValues);

    return {
      id,
      label: id,
      values: sortByOrderAndLabel(localeId)(values),
      count: R.pipe(R.filter(R.propEq(true, 'isSelected')), R.length)(values),
      hasPath: true, // if values are hierarchical and values path are computed by the parser
    };
  };
